<div class="ui-g">
  <div class="style2023 mb-2">
    <span
      style="
        display: inline-block;
        height: 18px;
        line-height: 18px;
        margin-right: 5px;
        font-weight: 600;
      "
    >
      Watched Jobs
    </span>
    <p-selectButton
      (onOptionClick)="showJobsValChanged($event)"
      [(ngModel)]="showOnlyUnassigned"
      [options]="[
        { label: 'Show Only Unassigned Jobs', value: 1 },
        { label: 'Show All Jobs', value: 0 }
      ]"
    >
    </p-selectButton>
  </div>

  <!--
  <div class="ui-g-6">
    <p-radioButton
      class="order-radio-button"
      name="showUnassigned"
      #showJobs
      value="0"
      [(ngModel)]="showJobsVal"
      (ngModelChange)="showJobsValChanged()"
      label="Show Only Unassigned Jobs"
      inputId="1"
    ></p-radioButton>
  </div>

  <div class="ui-g-6">
    <p-radioButton
      class="order-radio-button"
      name="showAll"
      #showJobs
      value="1"
      [(ngModel)]="showJobsVal"
      (ngModelChange)="showJobsValChanged()"
      label="Show All Jobs"
      inputId="2"
    ></p-radioButton>
  </div>
  -->
</div>

<div class="no-jobs" *ngIf="!isLoading && (!viewJobs || viewJobs.length == 0)">
  <div style="table: cell; vertical-align: middle">No Results</div>
</div>

<jobs-information-list
  [impersonating]="impersonating"
  [homePosition]="supplierHomePos"
  [jobs]="viewJobs"
  [busy]="isLoading"
></jobs-information-list>
